<div class="menu">
  <a href="/">Home</a> | <a href="/#/about">About</a>
</div>

<style>
  .menu {
    font-size: 0.8rem;
    font-weight: 400;
    text-transform: uppercase;
    padding-top: 10px;
    margin-bottom: 10px;

    line-height: 1.2rem;
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
  }
  .menu a {
    text-decoration: none;
    border-bottom: solid 1px #fff;
  }
</style>
